<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item @click="loadList()" v-if="statusInActive">
                <i class="cus-clock"></i>
                Reminders
            </b-nav-item>

            <b-nav-item-dropdown v-else>
                <template slot="button-content">
                    <i class="cus-clock"></i>
                    Reminders
                </template>
                <b-dropdown-item href="#0" @click="loadList()">
                    <i class="cus-clock"></i>View Reminders
                </b-dropdown-item>
                <div
                    class="dropdown-divider"
                    v-if="_hasAccess('patient.reminder.create')"
                ></div>
                <b-dropdown-item
                    v-if="_hasAccess('patient.reminder.create')"
                    @click.stop="showNewReminderBundleModal()"
                >
                    <i class="cus-add"></i> New Reminder Bundle
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="_hasAccess('patient.reminder.create')"
                    @click.stop="showNewReminderModal()"
                >
                    <i class="cus-add"></i> New Reminder
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <list-reminders :key="componentKey" :patientId="patientId" :patient="patientDetails" />
        </b-card-text>
    </b-tab>
</template>
<script>
export default {
    components: {
        ListReminders: () =>
            import("@/components/patient-reminders/reminder-list")
    },
    props: {
        patientDetails: {
            type: Object
        }
    },
    data() {
        return {
            componentKey: 0
        };
    },
    computed: {
        patientId() {
            return this.patientDetails ? this.patientDetails.id : null;
        },
        statusInActive() {
            return this.$store.getters["patient/statusInActive"];
        }
    },
    methods: {
        loadList() {
            this.componentKey += 1;
        },
        showNewReminderModal() {
            this.$parent.$parent.$refs.modalNewReminder.open();
        },
        showNewReminderBundleModal() {
            this.$parent.$parent.$refs.modalNewReminderBundle.open();
        }
    }
};
</script>
